import { render, staticRenderFns } from "./BusinessPackages.vue?vue&type=template&id=14700706"
import script from "./BusinessPackages.vue?vue&type=script&lang=js"
export * from "./BusinessPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports